import CalenderIcon from '@/common/assets/icons/dateIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { Box, Center } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const EditVisitTimeAction = ({ onClick }: { onClick?: () => void }) => {
  return (
    <Center
      borderTop="1px solid {colors.gray-2}"
      py="12px"
      cursor="pointer"
      onClick={onClick}
    >
      <Box display="flex" alignItems="center" gap="4px">
        <CalenderIcon stroke={token('colors.purple-2')} />
        <Typography textStyle="b4" color="purple-2">
          تعیین/ ویرایش زمان بازدید
        </Typography>
      </Box>
    </Center>
  );
};
export default EditVisitTimeAction;
